import CopyInfoForm from './CopyInfoForm';

export default CopyInfoForm;
